<app-container>
	<div class="flex">
		<atomic-name-badge
			size="medium"
			[icon]="ICON.CORPORATION"
		></atomic-name-badge>
		<div class="flex flex-col ml-5 justify-start">
			<span>{{ contactFirstName }} {{ contactLastName }}</span>
			<span>{{ name }}</span>
			<app-pill size="small" class="flex self-start">{{ type }}</app-pill>
		</div>
		<div class="ml-5">
			<div *ngIf="contactPhone">
				<app-icon [icon]="ICON.PHONE" class="mr-3 text-sm"></app-icon>
				<span class="hover:text-green hover:underline">
					<a
						externalNavInterceptor
						href="tel:{{ contactPhone }}"
						target="_blank"
					>
						{{ contactPhone }}
					</a>
				</span>
			</div>
			<div *ngIf="contactEmail">
				<app-icon [icon]="ICON.EMAIL" class="mr-3 text-sm"></app-icon>
				<span class="hover:text-green hover:underline">
					<a
						emailLinkInterceptor
						href="mailto:{{ contactEmail }}"
						target="_blank"
					>
						{{ contactEmail }}
					</a>
				</span>
			</div>
		</div>
	</div>
</app-container>
